module.exports = __webpack_public_path__ + "new-5455795b/template-6-preview-4ffb1c5bb2567b7d7022d04206e7d66d.jpg";